export default __webpack_public_path__ + "static/media/logo.c722f1f8.svg";